import { render, staticRenderFns } from "./PreparedSentMessages.vue?vue&type=template&id=38a64406&scoped=true&"
import script from "./PreparedSentMessages.vue?vue&type=script&lang=js&"
export * from "./PreparedSentMessages.vue?vue&type=script&lang=js&"
import style0 from "./PreparedSentMessages.vue?vue&type=style&index=0&id=38a64406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a64406",
  null
  
)

export default component.exports